import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { SnackbarProvider } from 'notistack'
import { ThemeProvider } from '@mui/material'

import SplashScreen from './SplashScreen'
import store from './store/configureStore'
import { themeSBM } from './sbm-theme'
import { reportWebVitals, Logger, LoggerTypes } from './utils'
import './i18n'
import './index.css'
import './sbm-theme/theme/style.css'

Logger.trace(LoggerTypes.INIT, 'index.js', { store, themeSBM })

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={themeSBM}>
      <SnackbarProvider maxSnack={3}>
        <Provider store={store}>
          <SplashScreen />
        </Provider>
      </SnackbarProvider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// serviceWorker.unregister()
reportWebVitals()
